import React from "react";
import { useNavigate } from "react-router-dom";
import "./StripeStatus.css";

const CancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="status-container cancel">
      <div className="status-card">
        <h1>❌ Payment Cancelled</h1>
        <p>Your subscription was not completed. Please try again to continue using <strong>Full Trucking Service</strong>.</p>
        <button className="status-btn danger" onClick={() => navigate("/login")}>
          Try Again
        </button>
      </div>
    </div>
  );
};

export default CancelPage;
